// src/utils/shapePresets.js
// Generic finished sizes; Mudo can apply shrinkage separately.

export const SHAPE_PRESETS = {
  mug: {
    label: "Mug",
    params: {
      height: 95,
      sections: [30, 35, 40, 42, 42],
      wall: 4,
      base: 6,
      sides: 12,
      morph: 1,
      twistDeg: 0,
      verticalSeg: 80,
      radialSeg: 96,
    },
  },
  plate: {
    label: "Plate",
    params: {
      height: 25,
      sections: [90, 110, 130, 130, 128],
      wall: 4,
      base: 5,
      sides: 24,
      morph: 1,
      twistDeg: 0,
      verticalSeg: 40,
      radialSeg: 96,
    },
  },
  bowl: {
    label: "Bowl",
    params: {
      height: 70,
      sections: [30, 55, 75, 80, 78],
      wall: 4,
      base: 6,
      sides: 12,
      morph: 1,
      twistDeg: 0,
      verticalSeg: 80,
      radialSeg: 96,
    },
  },
  vase: {
    label: "Vase",
    params: {
      height: 220,
      sections: [35, 55, 60, 40, 30],
      wall: 4,
      base: 8,
      sides: 12,
      morph: 1,
      twistDeg: 0,
      verticalSeg: 100,
      radialSeg: 96,
    },
  },
  planter: {
    label: "Planter",
    params: {
      height: 140,
      sections: [60, 70, 80, 80, 78],
      wall: 6,
      base: 10,
      sides: 12,
      morph: 1,
      twistDeg: 0,
      verticalSeg: 80,
      radialSeg: 96,
    },
  },
};
